import { condition } from "./condition";
export const reducer = (state, action) => {
  switch (action.type) {
    case condition.URL_DATA:
      return {
        ...state,
        urlData: action?.payload,
      };
    case condition.PDF_DATA:
      return {
        ...state,
        pdfData: action?.payload,
      };
    case condition.CACHE_TEXT_QNA:
      return {
        ...state,
        cacheTextQna: action?.payload,
      };
    case condition.CACHE_MUTUAL_FUND:
      return {
        ...state,
        cacheMutualFund: action?.payload,
      };
    case condition.CACHE_GREETING:
      return {
        ...state,
        cacheGreeting: action?.payload,
      };
    case condition.CACHE_BING_QNA:
      return {
        ...state,
        cacheBingQna: action?.payload,
      };
    case condition.SETACTIVETAB:
      return {
        ...state,
        activeTab: action?.payload,
      };
    case condition.SETCTALINKS:
      return {
        ...state,
        ctaLinks: action?.payload,
      };
    case condition.SETPROMPTSLIST:
      return {
        ...state,
        promptsList: action?.payload,
      };
    case condition.LOGS_DATA:
      return {
        ...state,
        logsData: action?.payload,
      };
    case condition.ERROR_LOGS_DATA:
      return {
        ...state,
        errorLogsData: action?.payload,
      };
    default:
      return state;
  }
};
